import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserId } from "../../../redux/features/notification/notificationSlice";
import {
  setCurrBalance,
  setRefetchBalanceProfile,
} from "../../../redux/features/rewards/rewardsSlice";
import { setProfileUserData } from "../../../redux/features/leaderboards/leaderboardsSlice";
import { setUserIdLan } from "../../../redux/features/main/localizationSlice";
import {
  getUserProfile,
  getAllJourneyData,
  checkHasRatingModule,
  checkGotBadges,
  claimPoint,
  completionModule,
} from "../../../api/repositories";
import { setLocalStorage, lanSetting } from "../../../utils";
import { setInvalidToken } from "../../../redux/features/main/invalidTokenSlice";
import { dataJourney } from "../constant";

const useActions = (
  moduleTargetedComplete,
  setCompletion,
  getLastModule,
  getLastModuleSupport,
  trigerFetch,
  currModuleExit,
  setTrigerFetch,
  setRefetchJourney,
  setTrigerExitModule,
  reFetchLeftSection,
  setRefetchLeftSection,
) => {
  const reFetchBalanceProfile = useSelector(
    (state) => state.rewards.reFetchBalanceProfile,
  );
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [allJourneyData, setAllJourneyData] = useState([]);
  const [totalJourney, setTotalJourney] = useState(0);
  const [totalJourneyCompleted, setTotalJourneyCompleted] = useState(0);
  const [listJourney, setListJourney] = useState([]);
  const [listCourse, setListCourse] = useState([]);
  const [flagUpdatePicture, setFlagUpdatePicture] = useState(false);
  const [hasRating, setHasRating] = useState(-1);
  const [isSubmit, setIsSubmit] = useState(0);
  const [isCompleted, setIsCompleted] = useState(0);
  const [pointClaimed, setPointClaimed] = useState(0);
  const [isFetchRating, setIsFetchRating] = useState(true);
  const [badgesState, setBagdesState] = useState({
    badges_id: null,
    journey_id: null,
    badges_thumbnail: null,
    badges_name: null,
  });

  // var alldatauy = {
  //     rating:0,
  //     is_completed:0,
  //     is_submit:0,
  //     points:0,
  //     badges_id:null
  // }

  const fetchUserProfile = async () => {
    try {
      const { data, status } = await getUserProfile();
      dispatch(setInvalidToken(status));
      setUserData({
        userName: data.firstname + " " + data.lastname,
        userPosition: data.position,
        learningPoints: data.points,
        picture: data.picture,
        firstname: data.firstname,
        userId: data.id,
        userUsername: data.username,
        created_at: data.created_at,
        is_supervisor:
          data.is_supervisor !== undefined && data.is_supervisor !== ""
            ? data.is_supervisor
            : 0,
      });
      dispatch(setCurrBalance(parseInt(data.points)));
      dispatch(setUserId(parseInt(data.id)));
      dispatch(
        setProfileUserData({
          directorate: data.directorate,
          division: data.division,
          department: data.department,
          group: data.group,
          role: data.position,
          institution: data.institution,
          sub_unit: data.sub_unit,
          unit: data.unit,
          company: data.company_name
        }),
      );
      // dispatch(setProfileUserData(
      //     {
      //         directorate:"Directorate P",
      //         division:"",
      //         department:"",
      //         group:"",
      //         role:"",
      //         institution: ""
      //       }
      // ))
      dispatch(setUserIdLan(data.id));
      setLocalStorage(lanSetting.user_id, data.id);
    } catch (error) {
      console.log(error.message);
      setUserData({});
    } finally {
      dispatch(setRefetchBalanceProfile(false));
    }
  };

  const fetchAllListJourney = async () => {
    setLoading(true);
    try {
      const { data, status } = await getAllJourneyData();
      dispatch(setInvalidToken(status));
      setAllJourneyData([...data.journeys]);
      setTotalJourney(data.total);
      setTotalJourneyCompleted(data.complete);
      setListJourney([...createListJourney([...data.journeys])]);
      setListCourse([...createListCourse(data.journeys)]);
    } catch (error) {
      console.log(error.message);
      setAllJourneyData([]);
      setTotalJourney(0);
      setTotalJourneyCompleted(0);
      setListJourney([]);
      setListCourse([]);
    } finally {
      setLoading(false);
      setTrigerFetch(false);
      setRefetchJourney(false);
      if (reFetchLeftSection === true) setRefetchLeftSection(false);
    }
  };

  const createListJourney = (data) => {
    // return journey without course
    return data.map(({ course, ...item }) => item);
  };

  const createListCourse = (data) => {
    // return course only
    return [].concat(...data.map(({ course }) => course || []));
  };

  const checkHasRating = async () => {
    setIsFetchRating(true);
    try {
      const { status, data } = await checkHasRatingModule(currModuleExit.id);
      // console.log("data checkHasRatingModule", data);
      dispatch(setInvalidToken(status));
      if (status === 200) {
        setHasRating(data.has_rating);
        setIsSubmit(data.is_submit);
        setIsCompleted(data.is_completed);
      } else {
        setHasRating(-1);
        setIsSubmit(0);
        setIsCompleted(0);
        console.log("Status invalid");
      }
    } catch (err) {
      setTrigerExitModule(false);
      setHasRating(-1);
      setIsSubmit(0);
      setIsCompleted(0);
      console.log("Check Rating Error", err.message);
    } finally {
      checkBadges();
    }
  };

  const checkBadges = async () => {
    const payload = {
      journey_id: currModuleExit.journey_id,
      course_id: currModuleExit.course_id,
      scorm_id: currModuleExit.scorm_id,
    };
    try {
      const { status, message, data } = await checkGotBadges({ data: payload });
      dispatch(setInvalidToken(status));
      if (status === 200) {
        if (data.length > 0) {
          setBagdesState((prevState) => {
            return {
              ...prevState,
              badges_id: data[0].id,
              journey_id: data[0].journey_id,
              badges_thumbnail: data[0].thumbnail,
              badges_name: data[0].name,

              //   badges_id: 30,
              //   journey_id: 45,
              //   badges_thumbnail:
              //     "https://learning-business-showcase.digimasia.com//assets/images/1747972347.png",
              //   badges_name: "Badges 1",
              //               {
              //     "id": 30,
              //     "journey_id": 45,
              //     "course_id": 77,
              //     "name": "Badges 1",
              //     "description": "badges 1 description",
              //     "has_point": 1,
              //     "thumbnail": "https://learning-business-showcase.digimasia.com//assets/images/1747972347.png",
              //     "type": "module",
              //     "journey_name": "Identify Customer Need"
              // }
            };
          });
        } else {
          setBagdesState((prevState) => {
            return {
              ...prevState,
              badges_id: null,
              journey_id: null,
              badges_thumbnail: null,
              badges_name: null,
              //   badges_id: 30,
              //   journey_id: 45,
              //   badges_thumbnail:
              //     "https://learning-business-showcase.digimasia.com//assets/images/1747972347.png",
              //   badges_name: "Badges 1",
            };
          });
        }
      } else {
        setBagdesState((prevState) => {
          return {
            ...prevState,
            badges_id: null,
            journey_id: null,
            badges_thumbnail: null,
            badges_name: null,
            // badges_id: 30,
            // journey_id: 45,
            // badges_thumbnail:
            //   "https://learning-business-showcase.digimasia.com//assets/images/1747972347.png",
            // badges_name: "Badges 1",
          };
        });
        console.log("Status invalid");
      }
    } catch (err) {
      setTrigerExitModule(false);
      setBagdesState((prevState) => {
        return {
          ...prevState,
          badges_id: null,
          journey_id: null,
          badges_thumbnail: null,
          badges_name: null,
          //   badges_id: 30,
          //   journey_id: 45,
          //   badges_thumbnail:
          //     "https://learning-business-showcase.digimasia.com//assets/images/1747972347.png",
          //   badges_name: "Badges 1",
        };
      });
      console.log("Check Badges Error", err.message);
    } finally {
      // ini dummy dulu idnya 16 ya
      checkGotPoint();
    }
  };

  const checkGotPoint = async () => {
    try {
      const { status, data } = await claimPoint(
        parseInt(userData.userId),
        parseInt(currModuleExit.id),
      );
      dispatch(setInvalidToken(status));
      if (status === 200) {
        if (Array.isArray(data) === true) {
          if (data.length > 0) {
            if (data[0].deleted === null || data[0].deleted === 0) {
              // if deleted === null then point has not claimed yet
              setPointClaimed(parseInt(data[0].point)); // get point on first array
            } else {
              console.log("DELETED point not NULL || 0");
              setPointClaimed(0);
            }
          }
        }
      } else {
        setPointClaimed(0);
        console.log("Status invalid");
      }
    } catch (err) {
      setTrigerExitModule(false);
      setPointClaimed(0);
      console.log("Claim Point Error", err.message);
    } finally {
      // setTrigerExitModule(false)
      setIsFetchRating(false);
    }
  };

  const checkCompletion = async () => {
    const lastModule = getLastModule?.modules;
    const lastModuleSupport = getLastModuleSupport?.modules;

    // console.log("lastModule", lastModule);
    // console.log("lastModuleSupport", lastModuleSupport);

    const selectedModule =
      lastModule &&
      lastModule.length > 0 &&
      lastModule.find(
        (dataModule) => parseInt(dataModule.id) === moduleTargetedComplete.id,
      );

    const selectedModuleSupport =
      lastModuleSupport &&
      lastModuleSupport.length > 0 &&
      lastModuleSupport.find(
        (dataModule) => parseInt(dataModule.id) === moduleTargetedComplete.id,
      );

    // console.log("selectedModule", selectedModule);
    // console.log("selectedModuleSupport", selectedModuleSupport);

    if (selectedModule !== undefined && selectedModule.is_complete === 1)
      callCompletion(selectedModule);
    if (
      selectedModuleSupport !== undefined &&
      selectedModuleSupport.is_complete === 1
    )
      callCompletion(selectedModuleSupport);
    if (selectedModule !== undefined && selectedModule.is_complete === 0) {
      setIsFetchRating(false);
    }
    if (
      selectedModuleSupport !== undefined &&
      selectedModuleSupport.is_complete === 0
    ) {
      setIsFetchRating(false);
    }
    setCompletion(false);
  };

  const callCompletion = async (module) => {
    // alert(module.fullname);
    const payload = {
      journey_id: module.journey_id,
      scorm_id: module.scorm_id,
      module_id: module.id,
      course_id: module.course_id,
    };

    try {
      const { status } = await completionModule({ data: payload });
      dispatch(setInvalidToken(status));
      if (status === 200) {
        console.log("completed module");
      } else {
        console.log("Status invalid");
      }
    } catch (err) {
      console.log("Call Completion Error", err.message);
    } finally {
      checkHasRating();
    }
  };

  useEffect(() => {
    // fetchUserProfile()
    fetchAllListJourney();
  }, []);

  useEffect(() => {
    if (trigerFetch === true) fetchAllListJourney();
  }, [trigerFetch]);

  useEffect(() => {
    fetchUserProfile();
  }, [flagUpdatePicture]);

  useEffect(() => {
    if (reFetchBalanceProfile === true) fetchUserProfile();
  }, [reFetchBalanceProfile]);

  return {
    loading,
    userData,
    totalJourney,
    totalJourneyCompleted,
    allJourneyData,
    listJourney,
    listCourse,
    flagUpdatePicture,
    hasRating,
    isSubmit,
    isCompleted,
    pointClaimed,
    badgesState,
    setFlagUpdatePicture,
    checkHasRating,
    checkCompletion,
    setHasRating,
    setIsSubmit,
    setIsCompleted,
    setPointClaimed,
    setBagdesState,
    fetchUserProfile,
    isFetchRating,
    setIsFetchRating,
  };
};

export default useActions;
